@if (
  ((gridName === 'CaseSearch' || gridName === 'CopyCase') &&
    globals &&
    globals.user.managerUnitCount &&
    globals.user.managerUnitCount > 0) ||
  (gridName !== 'CaseSearch' && gridName !== 'CopyCase')
) {
  <mat-form-field class="me-2 unit-select">
    <mat-label>{{ field.label }}</mat-label>
    <input
      type="text"
      matInput
      [placeholder]="field.label"
      [matAutocomplete]="autoUnit"
      [formControl]="unitControl"
      (blur)="onBlur($event)"
    />
    <mat-autocomplete
      #autoUnit="matAutocomplete"
      (optionSelected)="changeSelection($event)"
    >
      @if (dropdownLoading) {
        <mat-option disabled class="dropdownLoadingSpinner"
          ><mat-spinner diameter="48"
        /></mat-option>
      }
      @if (!dropdownLoading && dropdownNoResults) {
        <mat-option disabled>No Results</mat-option>
      }
      @if (!dropdownLoading && !dropdownNoResults) {
        @for (opt of getDropdownOptions(); track opt.value) {
          <mat-option value="{{ opt.value }}" class="custom-select-option">
            {{ opt.value }}: {{ opt.display }}
          </mat-option>
        }
      }
    </mat-autocomplete>
    @if (showClearButton(field.varName)) {
      <button
        matSuffix
        mat-icon-button
        aria-label="Clear"
        color="warn"
        type="button"
        matTooltip="Clear Filter"
        (click)="resetFilter($event)"
      >
        <mat-icon>close</mat-icon>
      </button>
    }
    @if (field.conditionalHint) {
      <mat-hint>{{ field.conditionalHint }}</mat-hint>
    }
  </mat-form-field>
}
